var $d6d2588377fc9718$exports = {};
$d6d2588377fc9718$exports = {
  "Clear search": "\u015Eterge\u0163i c\u0103utarea"
};
export { $d6d2588377fc9718$exports as default };